/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_LoginInputs */

const en_enum_setting_group_login = /** @type {(inputs: Enum_Setting_Group_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Login`)
};

const de_enum_setting_group_login = /** @type {(inputs: Enum_Setting_Group_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Login`)
};

/**
* | output |
* | --- |
* | "Group Login" |
*
* @param {Enum_Setting_Group_LoginInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_login = /** @type {((inputs?: Enum_Setting_Group_LoginInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_LoginInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_login(inputs)
	return de_enum_setting_group_login(inputs)
});